export const store = {
  state: {
    addressData: [],
    isInit: false
  },
  updateAddress (addressData) {
    this.state.addressData = addressData;
  },
  isInit () {
    return this.state.addressData.length > 0;
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/cascader/store.js